import angular from 'angular';
import APIV5 from '~/models/api';

export default class ESignService {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.$injector = $injector;
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} node_kid
	 */
	async create(node_kid) {
		const signResult = await APIV5.instance.eSignCreate({
			node_kid,
		}, {
			id: 'e-sign-service.create',
		});
		if (signResult?.url) {
			window.open(signResult.url, '_blank');
		}
	}
}

// eslint-disable-next-line unicorn/prevent-abbreviations
const eSignService = /* @ngInject */ (
	/** @type {import('angular').auto.IInjectorService} */ $injector,
) => new ESignService($injector);

angular.module('app')
	.factory('ESignService', eSignService);
